<template>
  <div class="symptomInfo">
    <div
      class="bt"
      :class="'b' + item.type"
      v-for="(item, index) in dsListFilter"
      :key="index"
    >
      <span>{{ item.label }}：</span>
      <span>{{ item.dsNames }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  watch: {
    list: {
      handler(val) {
        this.init();
      },
    },
  },
  data() {
    return {
      dsList: [
        {
          label: "加重",
          dsNames: "",
          type: 1,
        },
        {
          label: "减轻",
          dsNames: "",
          type: 2,
        },
        {
          label: "消失",
          dsNames: "",
          type: 3,
        },
      ],
    };
  },
  computed: {
    dsListFilter() {
      return this.dsList.filter((i) => i.dsNames);
    },
  },
  methods: {
    init() {
      this.dsList.map((i) => {
        let arr = this.list
          ? this.list.filter((j) => j.symptomChanges == i.type)
          : [];
        i.dsNames = arr.map((j) => j.dsName).join("、");
      });
    },
  },
  created() {
    this.init();
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.symptomInfo {
  .bt {
    display: inline-block;
    border-radius: 3px;
    margin: 0 10px 10px 0;
    padding: 2px 10px;
  }
  .b1 {
    background: #ffe6e7;
    color: #f0524d;
  }
  .b2 {
    background: #caeed0;
    color: #2c9633;
  }
  .b3 {
    background: #9d9d9d;
    color: #fff;
  }
  .b4 {
    border: 1px solid #616161;
    color: #616161;
  }
}
</style>